import * as t from 'io-ts'

import { AttachmentDto } from '@espoon-voltti/nuora-app-common/services/dtos'

import {
  ApprovedPreReportDecision,
  RejectedPreReportDecision,
  ApprovedPostReportDecision,
  RejectedPostReportDecision
} from '../../../domain/grants/report'

export const ReportDto = t.type(
  {
    attachments: t.array(AttachmentDto)
  },
  'ReportDto'
)
export type ReportDto = t.TypeOf<typeof ReportDto>

export const maybeRejectedPreReportDecisionData = {
  preReport: t.union([t.null, ReportDto]),
  preReportDecision: t.union([t.null, RejectedPreReportDecision])
}

export const maybeApprovedPreReportDecisionData = {
  preReport: t.union([t.null, ReportDto]),
  preReportDecision: t.union([t.null, ApprovedPreReportDecision])
}

export const maybeApprovedPostReportDecisionData = {
  postReport: t.union([t.null, ReportDto]),
  postReportDecision: t.union([t.null, ApprovedPostReportDecision])
}

export const rejectedPostReportDecisionData = {
  postReport: ReportDto,
  postReportDecision: RejectedPostReportDecision
}
